export default {
  singleLabel: "FAQ",
  storeNamespace: 'faq',
  authFeature: 'faq',
  listRouteName: "FaqList",
  newRouteName: "FaqNew",
  editRouteName: "FaqEdit",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'FaqForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'question',
  sortBy: 'position',
  sortable: true,
  fields: [{
      name: 'question',
      label: "Question",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
    },
    {
      name: 'answer',
      label: "Réponse",
      type: 'textarea',
      inForm: true,
      required: false,
      inList: true,
      filterIn: true,
    },
    {
      name: 'video_url',
      label: "URL vidéo",
      type: 'text',
      inForm: true,
      required: false,
      inList: true,
      filterIn: false,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Faq/config.js